"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorSchema = void 0;
exports.AnchorSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/anchor.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Anchor",
    "description": "Navigational anchors in texts, facilitating direct access to specific content sections.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:anchor"
            ]
        },
        "urlFragment": {
            "description": "Specifies a unique identifier for URL fragments (after the '#'), enabling direct navigation to specific content sections.",
            "type": "string"
        }
    },
    "required": [
        "type",
        "urlFragment"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5jaG9yLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvYW5jaG9yLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLFlBQVksR0FBRztJQUMxQixLQUFLLEVBQUUsK0RBQStEO0lBQ3RFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLFFBQVE7SUFDakIsYUFBYSxFQUFFLHlGQUF5RjtJQUN4RyxNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixtQkFBbUI7YUFDcEI7U0FDRjtRQUNELGFBQWEsRUFBRTtZQUNiLGFBQWEsRUFBRSwySEFBMkg7WUFDMUksTUFBTSxFQUFFLFFBQVE7U0FDakI7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixhQUFhO0tBQ2Q7Q0FDRixDQUFBIn0=